import React from 'react';
import styles from './EmptyState.module.css';

class EmptyState extends React.Component {
  render() {
    const { icon, title, description, action } = this.props;

    return (
      <div className={styles.wrap}>
        {icon && (
          <div className={styles.icon}>
            <span className="material-symbols-rounded" style={{ fontSize: 40 }}>{icon}</span>
          </div>
        )}
        <div className={styles.title}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
        {action && <div className={styles.action}>{action}</div>}
      </div>
    );
  }
}

export default EmptyState;
